import {FormItemModel, FormItemNumberModel, FormOptionsModel} from '../../../services/models/form.model';
import {RequesterResponseModel} from '../../../services/models/requester.model';

export class AccountPageResponceModel {
    status: RequesterResponseModel;
    form: AccountPageModel;
}

export class AccountPageModel {
    first_name: FormItemModel; // tslint:disable-line:variable-name
    last_name: FormItemModel; // tslint:disable-line:variable-name
    login: string;
    password1: FormItemModel;
    password2: FormItemModel;
    email: FormItemModel;
    phone: FormItemModel;
    manager_name: string; // tslint:disable-line:variable-name
    company_name: string; // tslint:disable-line:variable-name
    role_title: string; // tslint:disable-line:variable-name
    lang_id: FormItemNumberModel; // tslint:disable-line:variable-name
    available_languages: any[];
    options: FormOptionsModel;
    error: any;
}
